{
  "uigNews": {
    "more": "mehr",
    "widgetTitle": "Aktuelles",
    "widgetHeaderMore": "mehr"
  }
}
